module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/thirtyone-8284824e9fb5b30aa3829c470df19922.jpg";